import { apiClient } from "../../../../api/client/apiClient";
import { ENDPOINTS } from "../../../../api/config/endpoints";
import type { ApiResponse } from "../../../../api/types";
import type { AccountType } from "../../domain/models/AccountType";
import type { ServiceLine } from "../../domain/models/ServiceLine";
import type { OnboardingRepository } from "../../domain/repositories/OnboardingRepository";
import type { OnboardingOptionsDto, PartnerOnboardingDto } from "../dtos/onboardingOptionsDto";

type OnboardingOptionsResponse = ApiResponse<OnboardingOptionsDto>;
type PartnerOnboardingResponse = ApiResponse<PartnerOnboardingDto>;

export function createOnboardingRepository(): OnboardingRepository {
  return {
    async getAccountTypes(): Promise<AccountType[]> {
      const res = await apiClient<OnboardingOptionsResponse>(ENDPOINTS.ONBOARDING.OPTIONS, {
        method: "GET",
        apiCache: { mode: "memory", ttlMs: 60_000 },
      });
      return res.data.accountTypes ?? [];
    },

    async getServiceLines(): Promise<ServiceLine[]> {
      const res = await apiClient<OnboardingOptionsResponse>(ENDPOINTS.ONBOARDING.OPTIONS, {
        method: "GET",
        apiCache: { mode: "memory", ttlMs: 60_000 },
      });
      return (res.data.serviceLines ?? []) as ServiceLine[];
    },

    async submitAccountType(accountType: "BUSINESS" | "INDIVIDUAL"): Promise<void> {
      await apiClient(ENDPOINTS.ONBOARDING.SUBMIT, {
        method: "POST",
        body: { accountType },
      });
    },

    async submitServiceLine(args: { accountType: string; serviceLine: string }): Promise<void> {
      await apiClient(ENDPOINTS.ONBOARDING.SUBMIT, {
        method: "POST",
        body: args,
      });
    },

    async getPartnerOnboarding(): Promise<PartnerOnboardingDto> {
      const res =
        await apiClient<PartnerOnboardingResponse>(
          ENDPOINTS.ONBOARDING.SUBMIT,
          {
            method: "GET",
          }
        );

      return res.data;
    },
  };
}

